import * as React from "react";
import { Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { ISearchResult } from "../types";
import { searchContribContainer } from "../contrib";
import { selectKeyword, setKeyword, setResults } from "../store";

const SearchInput: React.FC<{style?: React.CSSProperties}> = props => {
    const keyword = useSelector(selectKeyword);
    const dispatch = useDispatch();
    return <>
        <Input.Search
            style={props.style}
            defaultValue={keyword}
            value={keyword}
            onChange={e => {
                dispatch(setKeyword(e.target.value));
            }}
            onSearch={e => {
                Promise.all(
                    searchContribContainer.contribs.map(c => c.search(e))
                ).then(res => {
                    const results: ISearchResult[] = [];
                    res.forEach(r => results.push(...r));
                    dispatch(setResults(results));
                });
            }}
        />
    </>;
};

export default SearchInput;
